import React, { Component } from "react";
import { Button } from "../Button";
import {
  DigestBox,
  DigestWrap,
  DigestRow,
  Column1,
  TextWrap,
  Top,
  Header,
  Subtitle,
  ButtonWrap,
  Column2,
  ImgWrap,
  Img,
} from "./atoms";

class Digest extends Component {
  constructor(props) {
    super(props);
    this.state = {
      img: null,
    };
  }
  componentDidMount() {
    import(`../../images/${this.props.img}`).then((res) => {
      this.setState({ img: res.default });
    });
  }
  render() {
    return (
      <>
        <DigestBox lightBg={this.props.lightBg} id={this.props.id}>
          <DigestWrap>
            <DigestRow imgStart={this.props.imgStart}>
              <Column1>
                <TextWrap>
                  <Top>{this.props.topLine}</Top>
                  <Header lightText={this.props.lightText}>
                    {this.props.headLine}
                  </Header>
                  <Subtitle darkText={this.props.darkText}>
                    {this.props.description}
                  </Subtitle>
                  <ButtonWrap>
                    {/* <Button
                      to="home"
                      primary={this.props.primary ? 1 : 0}
                      dark={this.props.dark ? 1 : 0}
                      // dark2={dark2 ? 0 : 1}
                      smooth={true}
                      duration={500}
                      spy={true}
                      exact="true"
                      offset={-80}
                    >
                      {this.props.buttonLabel}
                    </Button> */}
                  </ButtonWrap>
                </TextWrap>
              </Column1>
              <Column2>
                <ImgWrap>
                  <Img src={this.state.img} alt={this.props.alt} />
                </ImgWrap>
              </Column2>
            </DigestRow>
          </DigestWrap>
        </DigestBox>
      </>
    );
  }
}

export default Digest;
